import { RadioButtonGroup } from "../../../components/Decision/RadioButtonGroup";
import { FormTextArea } from "../../../components/Input/FormTextArea";
import { CommonUserTaskNew } from "../CommonUserTaskNew";
import type { ComponentConfig } from "../types";
import { useState } from 'react';
import ErrorMessages from "../../../components/ErrorMessages/ErrorMessage";
import { CaseDetailsFormConfig } from "./CaseDetails";
import { PaddingContainer } from "./style";

const ManualRefundReview = (props: any) => {
  const { flow } = props;

  const loadedDecision = props?.task?.data?.isRefundOk ?? null;
  const loadedComment = props?.task?.data?.refundComment ?? "";

  const initialDecisionString = loadedDecision === true ? 'true' 
    : loadedDecision === false ? 'false' 
    : null;


  // States
  const [decision, setDecision] = useState<boolean | null>(loadedDecision);
  const [decisionString, setDecisionString] = useState<string | null>(initialDecisionString);
  const [comment, setComment] = useState<string>(loadedComment);
  const [errorMessages, setErrorMessages] = useState<string>("");

  const handleDecisionChange = (value: string) => {
    const boolValue = value === 'true';
    setDecision(boolValue);
    setDecisionString(value);
  };


  const onComplete = () => {
    if (decision === null) {
      setErrorMessages("Please select a decision");
      return;
    }

    const formData = {
      isRefundOk: decision,
      refundComment: comment,
    };

    props.complete(
      formData,
      () => { },
      (e: any) => {
        console.log(e);
        setErrorMessages(e?.detail);
      },
    );
  }
  const onSave = () => {
    const formData = {
      isRefundOk: decision,
      refundComment: comment,
    };
    props.save(formData,
      () => console.log("success"),
      (e: any) => {
        console.log(e);
        setErrorMessages(e?.detail);
      },
    )
  }

  const formConfig: ComponentConfig[] = [
    {
      component: (
        <PaddingContainer>
          <div style={{
            fontSize: "14px",
            fontWeight: "bold",
            marginBottom: "1rem",
            color: "#1e1e1e"
          }}>Case Details</div>
          <CaseDetailsFormConfig flow={flow.data} />
        </PaddingContainer>
      ),
      order: 1,
    },
    {
      component: (
        <RadioButtonGroup
          radioButtonValue={decisionString}
          onChange={handleDecisionChange}
          title="Decision"
          options={[
            { value: 'true', label: 'Approve refund' },
            { value: 'false', label: 'Reject refund' },
          ]}
          id="check-manual-handling"
        />
      ),
      order: 4,
    },
    {
      component: (
        <FormTextArea
          name="Comment"
          onChange={(e: string) => setComment(e)}
          label="Comment"
          defaultValue={comment || ""}
          placeholder="Refund comment"
        />
      ),
      order: 5,
    },
    {
      component: <ErrorMessages errors={[errorMessages]} />,
      order: 6,
      hide: errorMessages === "",
    },
  ];

  return (
    <CommonUserTaskNew
      handleComplete={onComplete}
      handleSave={onSave}
      formConfig={formConfig}
      overrideMasonryColumns={2}
    />
  );
};

export default ManualRefundReview;

